<section id="press-releases" class="component component--press-releases press-releases bg-color-lightest text-color-dark">
	<div class="wrapper">
		<h2 class="component__title" *ngIf="convenorWpData.cb_heading != ''">{{ convenorWpData?.cb_heading }} <a href="javascript:void(0);" *ngIf="convenorWpData.add_button == 'yes'" (click)="openFormModal( convenorWpData.form_button_title, convenorWpData.form_button_content )" class="btn btn-primary btn-circle"><span>{{ convenorWpData.button_title != '' ?  convenorWpData.button_title : 'Add your pressrelease' }}</span></a></h2>
		<div class="masonry-section masonry-section-js convenor-grid row">
			<div class="grid-sizer-2"></div>
			<div class="col-12 col-sm-6 masonry-item convenor-grid-item" *ngFor="let item of convenorDotNetData">
				<a href="{{ fix_url( item.link ) }}" target="_blank" class="press-releases__repeater news__link">
					<span class="news_date">{{ item.date }}</span>
					<h3 class="press-releases__title" [innerHtml]="item.headline"></h3>
					<p [innerHtml]="item.organizationName"></p>
				</a>
			</div>
		</div>
		<div class="row" *ngIf="convenorWpData.cb_show_more == 'yes' && convenorDotNetData.length > 0 && convenorDotNetData.length > 10">
			<div class="col-12 text-center load-more link-wrapper">
				<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more">See more <span><i class="icon-breadcrumb-bottom"></i></span></a>
			</div>
		</div>
		<div class="hide show-in-mobile text-center">
			<a href="javascript:void(0);" *ngIf="convenorWpData.add_button == 'yes'" (click)="openFormModal( convenorWpData.form_button_title, convenorWpData.form_button_content )" class="btn btn-primary btn-circle"><span>{{ convenorWpData.button_title != '' ?  convenorWpData.button_title : 'Add your pressrelease' }}</span></a>
		</div>
	</div>
</section>